import { useNavigate, useParams } from 'react-router-dom';
import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { yupErrorMsg } from '../../../../components/atoms/const';
import api from '../../../../components/api';
import clientByIdDummy from '../detail/clientById.json';

export interface State {
  'clientCount': string,
  'state': string
}

interface BusinessCategory {
  'category': string;
  'id': number
}

function useAddClient() {
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get clientId from url params : clients/add/:clientId
  */
  const { clientId } = useParams();

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Navigation Handler
  */
  const navigation = useNavigate();
  const onNavigateCancel = () => navigation('/clients');
  const onNavigateToClientDetail = () => navigation(`/clients/${clientId}`);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
   * Mode Form Changer
   * 1. setting mode into percentage
   * 2. setting mode into dollar fix price
   */
  const [currentMode, setCurrentMode] = React.useState<1 | 2>(1);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get Initial Data on Add Mode
  * 1. State List
  * 2. Business List
  */

  // 1. State List
  const { data: clientStateRes, isLoading: clientStateLoading } = useQuery(['getAllStates', 'clients'], api.clients.getAllStates);
  const stateList: {value: string, label: string}[] = React.useMemo(() => {
    const resData: State[] | undefined = clientStateRes?.data?.data;
    if (resData) {
      return resData.map((state) => ({
        value: state.state,
        label: state.state,
      }));
    }
    return [];
  }, [clientStateRes]);

  // 2. Business List
  const { data: businessRes, isLoading: businessLoading } = useQuery(['getAllBusinessCategory', 'clients'], api.clients.getAllBusinessCategory);
  const businessList: {value: number, label: string}[] = React.useMemo(() => {
    const resData: BusinessCategory[] | undefined = businessRes?.data?.data;
    if (resData) {
      return resData.map((business) => ({
        value: business.id,
        label: business.category,
      }));
    }
    return [];
  }, [businessRes]);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Add New Client or Edit Client
  * Will handling anything that are needed for add new client, this formik will auto add
  * to re-usable component from another form like : contact and partner. So.., please make
  * sure the formik key values same with that form
  */
  // 1. Add New Client
  const { isLoading: addClientLoad, mutate: addNewClient } = useMutation(api.clients.add, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log(res);
      alert('success');
      onNavigateToClientDetail();
    },
    onError: (err) => {
      console.log('err', err);
      alert('error');
    },
  });
  // 2. Edit Client
  // Submit Post Data to API
  const { isLoading: updateClientLoad, mutate: updateClient } = useMutation(api.clients.update, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log(res);
      alert('success');
      onNavigateToClientDetail();
    },
    onError: (err) => {
      console.log('err', err);
      alert('error');
    },
  });

  // Form Add
  const yupSchemaAdd = yup.object().shape({
    // client info
    name: yup.string().required(yupErrorMsg.COMPANY_NAME_EMPTY),
    streetAddress: yup.string().required(yupErrorMsg.STREET_ADDRESS_EMPTY),
    zipCode: yup.string().required(yupErrorMsg.ZIP_CODE_EMPTY).test('len', yupErrorMsg.ZIP_CODE_INCORRECT_FORMAT, (val: any) => (val ? val.toString().length === 5 : false)),
    state: yup.string().required(yupErrorMsg.STATE_EMPTY),
    city: yup.string().required(yupErrorMsg.CITY_EMPTY),
    categoryId: yup.string().required(yupErrorMsg.BUSINESS_CATEGORY_EMPTY),
    commision: yup.number().min(0, yupErrorMsg.COMMISION_POSITIVE).required(yupErrorMsg.COMMISION_EMPTY),
    // contact person
    firstname: yup.string().required(yupErrorMsg.FIRST_NAME_EMPTY),
    lastname: yup.string().required(yupErrorMsg.LAST_NAME_EMPTY),
    email: yup.string().email(yupErrorMsg.EMAIL_INCORRECT_FORMAT).required(yupErrorMsg.EMAIL_EMPTY),
    phoneNumber: yup.string().required(yupErrorMsg.PHONE_NUMBER_EMPTY),
    position: yup.string().required(yupErrorMsg.POSITION_EMPTY),
    role: yup.string().required(yupErrorMsg.ROLE_EMPTY),
  });
  // Validation Form
  const yupSchemaUpdate = yup.object().shape({
    // client info
    name: yup.string().required(yupErrorMsg.COMPANY_NAME_EMPTY),
    streetAddress: yup.string().required(yupErrorMsg.STREET_ADDRESS_EMPTY),
    zipCode: yup.string().required(yupErrorMsg.ZIP_CODE_EMPTY).test('len', yupErrorMsg.ZIP_CODE_INCORRECT_FORMAT, (val: any) => (val ? val.toString().length === 5 : false)),
    state: yup.string().required(yupErrorMsg.STATE_EMPTY),
    city: yup.string().required(yupErrorMsg.CITY_EMPTY),
    categoryId: yup.string().required(yupErrorMsg.BUSINESS_CATEGORY_EMPTY),
    commision: yup.number().min(0, yupErrorMsg.COMMISION_POSITIVE).required(yupErrorMsg.COMMISION_EMPTY),
  });
  // Form Handler
  const addClientFormik = useFormik({
    initialValues: !clientId ? {
      // client info
      name: '',
      streetAddress: '',
      zipCode: '',
      state: '',
      city: '',
      categoryId: '',
      commision: 0,
      // contact person
      firstname: '',
      lastname: '',
      position: '',
      phoneNumber: '',
      email: '',
      role: '',
      comPref: '',
      // partner
      partnerId: '',
      partnerCommission: 0,
    } : {
      // client info
      name: '',
      streetAddress: '',
      zipCode: '',
      state: '',
      city: '',
      categoryId: '',
      commision: 0,
      // partner
      partnerId: '',
      partnerCommission: 0,
    },
    validationSchema: clientId ? yupSchemaUpdate : yupSchemaAdd,
    onSubmit: ((values) => {
      const data = {
        name: values.name,
        address: {
          streetAddress: values.streetAddress,
          zipCode: values.zipCode,
          state: values.state,
          city: values.city,
        },
        partnerId: values.partnerId === '' ? null : parseInt(values.partnerId, 10),
        partnerCommission: values.partnerCommission,
        commision: values.commision,
        categoryId: parseInt(values.categoryId, 10),
      };
      if (!clientId) {
        addNewClient({
          ...data,
          contactPerson: {
            firstname: values.firstname!,
            lastname: values.lastname!,
            position: values.position!,
            phoneNumber: values.phoneNumber!,
            email: values.email!,
            role: parseInt(values.role!, 10),
            comPref: parseInt(values.comPref!, 10),
          },
        });
      } else {
        updateClient({
          ...data,
          id: parseInt(clientId!, 10),
          addressChanged: true,
        });
      }
    }),
  });

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get Initial Data on Edit Mode from url params clientId
  */
  // Fetching Client Detail from Database
  const {
    data: clientByIdRes, isLoading: clientByIdLoad,
  } = useQuery(['getById', 'clients', clientId], () => api.clients.getById(clientId!), {
    enabled: !!clientId,
  });
  // Make sure the result only rendered twice, first before fetch, second after fetch
  const clientById :typeof clientByIdDummy | undefined = React.useMemo(() => clientByIdRes?.data?.data, [clientByIdRes]);
  // Place all the result of fetching into form value
  React.useEffect(() => {
    if (clientById) {
      addClientFormik.setFieldValue('name', clientById.name ?? '');
      addClientFormik.setFieldValue('streetAddress', clientById.address.streetAddress ?? '');
      addClientFormik.setFieldValue('zipCode', clientById.address.zipCode ?? '');
      addClientFormik.setFieldValue('state', clientById.address.state ?? '');
      addClientFormik.setFieldValue('city', clientById.address.city ?? '');
      addClientFormik.setFieldValue('categoryId', clientById.categoryId ?? '');
      addClientFormik.setFieldValue('commision', clientById.commission ?? 0);
      addClientFormik.setFieldValue('partnerId', clientById.partner.id ?? null);
      addClientFormik.setFieldValue('partnerCommission', clientById.partner.comission ?? 0);
    }
  }, [clientById]);

  return {
    clientId,
    currentMode,
    setCurrentMode,
    addClientFormik,
    onNavigateCancel,
    stateList,
    clientStateLoading,
    businessList,
    businessLoading,
    addClientLoad,
    updateClientLoad,
    clientById,
    clientByIdLoad,
  };
}

export default useAddClient;
